import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RoleCard = ({ 
  role, 
  isSelected, 
  onSelect, 
  title, 
  description, 
  features, 
  icon, 
  color,
  buttonText 
}) => {
  return (
    <div
      onClick={() => onSelect(role)}
      className={`relative p-8 rounded-2xl border-2 cursor-pointer transition-all duration-300 ${
        isSelected
          ? `border-${color} bg-${color}/5 shadow-elevation-lg transform scale-[1.02]`
          : 'border-border hover:border-muted-foreground/50 hover:shadow-elevation hover:transform hover:scale-[1.01]'
      }`}
    >
      <div className="flex flex-col items-center text-center space-y-6">
        <div className={`flex h-16 w-16 items-center justify-center rounded-2xl transition-all duration-300 ${
          isSelected
            ? `bg-${color} text-${color}-foreground shadow-lg`
            : 'bg-muted text-muted-foreground'
        }`}>
          <Icon name={icon} size={32} />
        </div>
        
        <div className="space-y-3">
          <h3 className="text-2xl font-semibold text-foreground">
            {title}
          </h3>
          <p className="text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>
        
        <ul className="space-y-3 w-full">
          {features?.map((feature, index) => (
            <li key={index} className="flex items-center space-x-3 text-sm">
              <Icon 
                name="Check" 
                size={18} 
                className={`flex-shrink-0 transition-colors duration-300 ${
                  isSelected
                    ? `text-${color}`
                    : 'text-muted-foreground'
                }`}
              />
              <span className="text-muted-foreground text-left">{feature}</span>
            </li>
          ))}
        </ul>

        <Button
          variant={isSelected ? "default" : "outline"}
          size="lg"
          fullWidth
          className="mt-6"
          iconName="ArrowRight"
          iconPosition="right"
        >
          {buttonText}
        </Button>
      </div>
      {isSelected && (
        <div className={`absolute top-6 right-6 h-8 w-8 rounded-full bg-${color} flex items-center justify-center shadow-lg animate-fade-in`}>
          <Icon name="Check" size={18} className={`text-${color}-foreground`} />
        </div>
      )}
    </div>
  );
};

export default RoleCard;